export enum navTabs {
  Contact = 'contact',
  Menu = 'menu',
  Offers = 'offers',
  Reviews = 'reviews',
  Services = 'services'
}
